module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_5_preview.529ee87a.jpg";